const rtn = {
  TYPES: { string: "string", number: "number" },
};

export default rtn;